import React from "react";

export type HomeworkActivityHelpField =
  | "nonExposureHomework"
  | "dueDate"
  | "repeats"
  | "recurrenceEndDate"
  | "activitySteps"
  | "modificationSteps"
  | "coachingPrompts"
  | "activityImages";

const homeworkActivityHelp: Record<
  HomeworkActivityHelpField,
  React.ReactNode
> = {
  nonExposureHomework:
    "When checked, the assistant will skip asking for SUDS ratings, coping skills used, and any altered steps for this homework.",
  dueDate: (
    <>
      Optional for one-time homework. Required for repeating homework (
      <strong>Repeats: Daily/Weekly</strong>).
    </>
  ),
  repeats: (
    <>
      Controls repeating. <strong>Daily</strong> repeats every day. {" "}
      <strong>Weekly</strong> repeats on selected weekdays.
    </>
  ),
  recurrenceEndDate:
    "Required for repeating homework. No new instances are created after this date. If blank, none will be created.",
  activitySteps: (
    <>
      Number each step and write clear, concrete instructions for what the client
      should do.
      <br />
      Each numbered step must be on its own line. Do not combine multiple steps on
      the same line.
    </>
  ),
  modificationSteps: (
    <>
      Provide 1–3{" "}
      <strong>
        approved modifications of the <em>same</em> activity steps
      </strong>{" "}
      to use when the client asks to make it easier, modify, or switch. Enter each{" "}
      <strong>modified step on a separate line</strong> (bullets ok: * or -).
    </>
  ),
  coachingPrompts: (
    <>
      Use coaching prompts as client coaching tips and/or parent scripts during{" "}
      <strong>timed</strong> activity steps.
    </>
  ),
  activityImages:
    "To display an image in an activity step, first upload the image file. Then add image: image_name at the end of the step where the image should appear. For example, image: toothpaste_amount.",
};

export function HomeworkActivityFieldHelp({
  field,
}: {
  field: HomeworkActivityHelpField;
}) {
  return (
    <p className="cp-form-help cp-homework-activity-form-help">
      {homeworkActivityHelp[field]}
    </p>
  );
}
